module.exports = __webpack_public_path__ + "assets/img/img314.d498ee45.png";